export class BlocklyError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "BlocklyError";
		this.cause = cause;
		this.info = info
	}
}

export class BlocklyInvalidXml extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "BlocklyInvalidXml";
		this.cause = cause;
		this.info = info
	}
}

export class BlocklyInvalidBlock extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "BlocklyInvalidBlock";
		this.cause = cause;
		this.info = info
	}
}

export class BlocklyCodeGenerationError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "BlocklyCodeGenerationError";
		this.cause = cause;
		this.info = info
	}
}

export class BlocklyWorkspaceXmlMismatch extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "BlocklyWorkspaceXmlMismatch";
		this.cause = cause;
		this.info = info
	}
}
export class BlocklyHighlightError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "BlocklyHighlightError";
		this.cause = cause;
		this.info = info
	}
}

export class FileSystemError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "FileSystemError";
		this.cause = cause;
		this.info = info
	}
}

export class InitializationError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "InitializationError";
		this.cause = cause;
		this.info = info
	}
}

export class SessionSocketError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "SessionSocketError";
		this.cause = cause;
		this.info = info
	}
}

export class SessionError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "SessionError";
		this.cause = cause;
		this.info = info
	}
}

export class CommunicationError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "CommunicationError";
		this.cause = cause;
		this.info = info
	}
}

export class AchievementError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "AchievementError";
		this.cause = cause;
		this.info = info
	}
}
export class UploadError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "UploadError";
		this.cause = cause;
		this.info = info
	}
}

export class QuizError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "QuizError";
		this.cause = cause;
		this.info = info
	}
}

export class IframeError extends Error {
	public cause?: Error;
	public info?: { [key: string]: any };

	constructor(message: string, cause?: Error, info?: { [key: string]: any }) {
		super(message);
		this.name = "IframeError";
		this.cause = cause;
		this.info = info
	}
}